import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { spacingMap } from '../../theming';
import { readHDSTheme } from '../../utils';
// Sets the component to render a `div` element with vertical spacing
const StyledBlockSpacer = styled.div.withConfig({
  displayName: "HDSSpacer__StyledBlockSpacer",
  componentId: "sc-1l3uwn3-0"
})(["height:", ";"], ({
  theme,
  $space
}) => readHDSTheme(theme).UNSTABLE_HDS[spacingMap[$space]]); // Sets the component to render a `span` element with horizontal spacing

const StyledInlineBlockSpacer = styled.span.withConfig({
  displayName: "HDSSpacer__StyledInlineBlockSpacer",
  componentId: "sc-1l3uwn3-1"
})(["width:", ";display:inline-block;"], ({
  theme,
  $space
}) => readHDSTheme(theme).UNSTABLE_HDS[spacingMap[$space]]);
export const HDSSpacer = ({
  display = 'block',
  space = '400'
}) => {
  const SpacerComponent = display === 'block' ? StyledBlockSpacer : StyledInlineBlockSpacer;
  return /*#__PURE__*/_jsx(SpacerComponent, {
    $display: display,
    $space: space
  });
};